import { render } from "./PageImportModal.vue?vue&type=template&id=01145e80&scoped=true"
import script from "./PageImportModal.vue?vue&type=script&lang=js"
export * from "./PageImportModal.vue?vue&type=script&lang=js"

import "./PageImportModal.vue?vue&type=style&index=0&id=01145e80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01145e80"]])

export default __exports__